/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ScheduledPruneDto } from '../models/ScheduledPruneDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RemoteDomainPruneControllerService {

    /**
     * @param name
     * @param component
     * @returns ScheduledPruneDto OK
     * @throws ApiError
     */
    public static getRemoteDomainPruningSchedule(
        name: string,
        component: string,
    ): CancelablePromise<ScheduledPruneDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/remote-domains/{name}/prune',
            path: {
                'name': name,
            },
            query: {
                'component': component,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @param component
     * @param requestBody
     * @returns any Created
     * @throws ApiError
     */
    public static createRemoteDomainPruningSchedule(
        name: string,
        component: string,
        requestBody: ScheduledPruneDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/remote-domains/{name}/prune',
            path: {
                'name': name,
            },
            query: {
                'component': component,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @param component
     * @returns void
     * @throws ApiError
     */
    public static deleteRemoteDomainPruningSchedule(
        name: string,
        component: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/remote-domains/{name}/prune',
            path: {
                'name': name,
            },
            query: {
                'component': component,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

}
